import { render } from "./ExpandButtonComponent.vue?vue&type=template&id=44d30e91&scoped=true&ts=true"
import script from "./ExpandButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ExpandButtonComponent.vue?vue&type=script&lang=ts"

import "./ExpandButtonComponent.vue?vue&type=style&index=0&id=44d30e91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d30e91"]])

export default __exports__